import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

interface PageLoadingStateProps {
  message?: string;
  className?: string;
  bg?: string;
}

export function PageLoadingState({
  message = "Loading...",
  className,
  bg = "bg-background",
}: PageLoadingStateProps) {
  return (
    <div
      className={cn(
        "min-h-screen flex items-center justify-center",
        bg,
        className
      )}
    >
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="h-8 w-8 animate-spin text-stone-400" />
        <p className="text-stone-500 font-serif italic">{message}</p>
      </div>
    </div>
  );
}
